"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _constants = require("./constants");

var _styles = require("./styles");

var _componentFields = require("@doordash/component-fields");

var _designLanguage = require("@doordash/design-language");

var _utilities = require("@doordash/utilities");

var _utils = require("./utils");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireDefault(require("lodash.get"));

var _invariant = _interopRequireDefault(require("invariant"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// https://www.w3.org/TR/wai-aria/states_and_properties#aria-checked
// https://www.w3.org/TR/2016/WD-wai-aria-practices-1.1-20160317/examples/radio/radio.html
// https://www.nngroup.com/articles/checkboxes-vs-radio-buttons/
var DefaultRenderLabel = function DefaultRenderLabel(_ref) {
  var htmlFor = _ref.htmlFor,
      label = _ref.label,
      isDisabled = _ref.isDisabled,
      size = _ref.size,
      color = _ref.color;
  return /*#__PURE__*/_react["default"].createElement(_styles.LabelContainer, {
    isDisabled: isDisabled,
    size: size
  }, /*#__PURE__*/_react["default"].createElement(_designLanguage.Text, {
    color: color,
    htmlFor: htmlFor,
    tag: "label",
    styles: _designLanguage.Text.Styles.Medium14
  }, label));
};

var PREFIX_ID = 'Toggle';
DefaultRenderLabel.propTypes = {
  htmlFor: _propTypes["default"].string.isRequired,
  label: _propTypes["default"].string.isRequired,
  isDisabled: _propTypes["default"].bool.isRequired,
  size: _propTypes["default"].number.isRequired,
  color: _propTypes["default"].string.isRequired
};

var Toggle = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Toggle, _React$PureComponent);

  var _super = _createSuper(Toggle);

  function Toggle() {
    var _defineProperty2;

    var _this;

    _classCallCheck(this, Toggle);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isFocused: false
    });

    _defineProperty(_assertThisInitialized(_this), "borderRadiusForType", (_defineProperty2 = {}, _defineProperty(_defineProperty2, _constants.Types.Radio, '100%'), _defineProperty(_defineProperty2, _constants.Types.Toggle, "".concat((0, _lodash["default"])(_this.context, 'BorderRadius.ToggleTypeToggle'), "px")), _defineProperty(_defineProperty2, _constants.Types.Checkbox, "".concat((0, _lodash["default"])(_this.context, 'BorderRadius.ToggleTypeCheckbox'), "px")), _defineProperty(_defineProperty2, _constants.Types.Circle, '100%'), _defineProperty2));

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      if (!_this.props.onChange) return;

      if (_this.props.isDisabled) {
        return;
      }

      _this.checkboxElement.focus();

      _this.props.onChange(!_this.props.isSelected, e);
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e) {
      if (!_this.props.onClick) return;

      if (_this.props.onChange && _this.props.onClick) {
        // eslint-disable-next-line no-console
        console.error("You should provide either an onClick or\n        an onChange, not both; an onClick is intended for\n        when you need to interact with the toggle but not\n        immediately update it, or when you need to select\n        it again with no state-change.");
      }

      if (_this.props.isDisabled) {
        return;
      }

      _this.checkboxElement.focus();

      _this.props.onClick(_this.props.isSelected, e);
    });

    _defineProperty(_assertThisInitialized(_this), "setCheckboxRef", function (el) {
      _this.checkboxElement = el;
    });

    _defineProperty(_assertThisInitialized(_this), "setDefaultLabelColorByState", function () {
      if (_this.props.error) {
        return 'TextError';
      }

      return Toggle.LabelColors.Primary;
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (e) {
      var onFocus = _this.props.onFocus;

      _this.setState({
        isFocused: true
      });

      if (onFocus) {
        onFocus(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (e) {
      var onBlur = _this.props.onBlur;

      _this.setState({
        isFocused: false
      });

      if (onBlur) {
        onBlur(e);
      }
    });

    return _this;
  }

  _createClass(Toggle, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          alignToggle = _this$props.alignToggle,
          justifyToggle = _this$props.justifyToggle,
          isDisabled = _this$props.isDisabled,
          isLabelHidden = _this$props.isLabelHidden,
          isSelected = _this$props.isSelected,
          label = _this$props.label,
          labelColor = _this$props.labelColor,
          labelSide = _this$props.labelSide,
          name = _this$props.name,
          onClick = _this$props.onClick,
          onChange = _this$props.onChange,
          renderLabel = _this$props.renderLabel,
          size = _this$props.size,
          type = _this$props.type,
          inputType = _this$props.inputType,
          uniqueId = _this$props.uniqueId,
          error = _this$props.error,
          accessibilityDescribedBy = _this$props.accessibilityDescribedBy,
          props = _objectWithoutProperties(_this$props, ["alignToggle", "justifyToggle", "isDisabled", "isLabelHidden", "isSelected", "label", "labelColor", "labelSide", "name", "onClick", "onChange", "renderLabel", "size", "type", "inputType", "uniqueId", "error", "accessibilityDescribedBy"]);

      var isCircle = type === _constants.Types.Circle;
      var shouldRenderLabel = !isLabelHidden && !isCircle;
      var toggleLabel = renderLabel({
        htmlFor: uniqueId,
        label: label,
        isDisabled: isDisabled,
        size: size,
        color: labelColor || this.setDefaultLabelColorByState(),
        isFocused: this.state.isFocused
      });
      var propsToForward = (0, _utilities.getPropsToForward)({
        props: props
      });

      if (!onChange && !onClick) {
        // eslint-disable-next-line no-console
        console.error("You should provide either an onClick or\n        an onChange; providing one of both is required\n        to use this controlled Toggle component.");
      }

      var isToggleHidden = type === _constants.Types.Custom;
      (0, _invariant["default"])(isToggleHidden ? typeof inputType !== 'undefined' : true, "When using toggle type Custom, you must provide an input type (either InputTypes.Radio or InputTypes.Checkbox) to the inputType prop");
      return /*#__PURE__*/_react["default"].createElement(_styles.ToggleContainer, propsToForward, /*#__PURE__*/_react["default"].createElement(_designLanguage.InlineChildren, {
        alignItems: (0, _utils.getInlineChildrenAlignment)(alignToggle),
        justifyContent: (0, _utils.getInlineChildrenJustification)(justifyToggle),
        size: isLabelHidden || isToggleHidden ? _designLanguage.InlineChildren.Sizes.None : _designLanguage.InlineChildren.Sizes.XxSmall
      }, shouldRenderLabel && labelSide === _constants.LabelSides.Leading && toggleLabel, /*#__PURE__*/_react["default"].createElement(_styles.InputContainer, {
        size: size,
        isCustom: type === _constants.Types.Custom
      }, /*#__PURE__*/_react["default"].createElement(_styles.ToggleInput, {
        borderRadius: this.borderRadiusForType[type],
        borderWidth: (0, _lodash["default"])(this.context, 'BorderWidth.Toggle'),
        themeSize: isCircle ? _constants.CircleSizes[size] : (0, _lodash["default"])(this.context, "Size.".concat((0, _utils.getToggleSizeSemantic)({
          size: size,
          type: type
        })), size),
        isToggleHidden: isToggleHidden,
        "aria-label": isLabelHidden ? label : null,
        "aria-describedby": accessibilityDescribedBy,
        label: isCircle && !isLabelHidden && label ? label : null,
        checked: !!isSelected,
        disabled: isDisabled,
        error: error,
        id: uniqueId,
        ref: this.setCheckboxRef,
        kind: type,
        name: name,
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        size: isCircle ? _constants.CircleSizes[size] : size,
        type: inputType || _constants.InputTypes[type],
        onClick: this.handleClick
      })), shouldRenderLabel && labelSide === _constants.LabelSides.Trailing && toggleLabel), shouldRenderLabel && error && /*#__PURE__*/_react["default"].createElement(_styles.ErrorMessageContainer, null, /*#__PURE__*/_react["default"].createElement(_componentFields.ErrorMessage, {
        error: error
      })));
    }
  }]);

  return Toggle;
}(_react["default"].PureComponent);

_defineProperty(Toggle, "contextType", _designLanguage.ThemingContext);

_defineProperty(Toggle, "Alignment", _constants.Alignment);

_defineProperty(Toggle, "Justification", _constants.Justification);

_defineProperty(Toggle, "LabelColors", {
  Black: _designLanguage.Text.Colors.TextPrimary,
  Dark: _designLanguage.Text.Colors.TextSecondary,
  Light: _designLanguage.Text.Colors.SystemWhite,
  Primary: _designLanguage.Text.Colors.TextPrimary,
  Tertiary: _designLanguage.Text.Colors.TextTertiary,
  Ghost: _designLanguage.Text.Colors.SystemGrey40,
  Red: _designLanguage.Text.Colors.SystemRed60,
  Error: _designLanguage.Text.Colors.TextError
});

_defineProperty(Toggle, "Sizes", _constants.Sizes);

_defineProperty(Toggle, "Types", _constants.Types);

_defineProperty(Toggle, "InputTypes", _constants.InputTypesRaw);

_defineProperty(Toggle, "LabelSides", _constants.LabelSides);

_defineProperty(Toggle, "propTypes", {
  alignToggle: _propTypes["default"].oneOf(Object.values(Toggle.Alignment)),
  justifyToggle: _propTypes["default"].oneOf(Object.values(Toggle.Justification)),
  size: _propTypes["default"].oneOf(Object.values(Toggle.Sizes)),
  isDisabled: _propTypes["default"].bool,
  isSelected: _propTypes["default"].bool.isRequired,
  isLabelHidden: _propTypes["default"].bool,
  error: _propTypes["default"].string,
  label: _propTypes["default"].string.isRequired,
  labelColor: _propTypes["default"].oneOf([].concat(_toConsumableArray((0, _utilities.getAllPropCasesForColors)(Object.values(Toggle.LabelColors))), _toConsumableArray(Object.values(Toggle.LabelColors)))),
  labelSide: _propTypes["default"].oneOf(Object.values(Toggle.LabelSides)),
  name: _propTypes["default"].string,
  onBlur: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  renderLabel: _propTypes["default"].func.isRequired,
  type: _propTypes["default"].oneOf(Object.values(Toggle.Types)),
  inputType: _propTypes["default"].oneOf(Object.values(Toggle.InputTypes)),
  accessibilityDescribedBy: _propTypes["default"].string,
  uniqueId: _propTypes["default"].string
});

_defineProperty(Toggle, "defaultProps", {
  size: _constants.Sizes.Large,
  alignToggle: _constants.Alignment.Start,
  isLabelHidden: false,
  labelSide: _constants.LabelSides.Trailing,
  renderLabel: DefaultRenderLabel,
  type: _constants.Types.Checkbox
});

var AnnotatedToggle = (0, _utilities.withUniqueId)(Toggle, {
  prefix: PREFIX_ID
});
AnnotatedToggle.Alignment = Toggle.Alignment;
AnnotatedToggle.Justification = Toggle.Justification;
AnnotatedToggle.LabelColors = Toggle.LabelColors;
AnnotatedToggle.Sizes = Toggle.Sizes;
AnnotatedToggle.Types = Toggle.Types;
AnnotatedToggle.InputTypes = Toggle.InputTypes;
AnnotatedToggle.LabelSides = Toggle.LabelSides;
var _default = AnnotatedToggle;
exports["default"] = _default;